module.exports = __webpack_public_path__ + "static/python-946732cf6f2013edeb81fe721d29fd02.svg";